<div class="detail-connected-item-container" [appSkeleton]="isLoading()">
  @if (itemConnected()) {
  <div class="item-header-container">
    <div class="item-header">
      <div class="item-header-row">
        <div class="item-header-title-block">
          <icon-induxtry [icon]="{ icon: 'arrow-left-new', width: '30px', height: '30px', stroke: '#000' }" (click)="onBack()" style="cursor: pointer;"></icon-induxtry>
          <span class="item-name">{{ itemConnected()!.name }}</span>
          @if (lastExecution(); as exec) {
            <icon-induxtry [title]="statusLabelMap[exec.status]" [icon]="{ icon: statusIconMap[exec.status], width: '24px', height: '24px' }"></icon-induxtry>
          }
          <span class="item-last-execution">
            Última execução:
            <span class="item-last-execution-value">
              {{ lastExecutionLabel() }}
            </span>
          </span>
        </div>
      </div>
    </div>
    @if (!isBBCEDataSetID()) {
    <div class="item-header-actions">
      <button-induxtry [buttonProperties]="{
        label: 'Execução',
        customStyle: 'primary',
        icon: 'Play',
        tooltip: 'Iniciar nova execução',
        customStyleFillIcon: true,
        loading: isLoadingExecution(),
      }" (action)="onStartExecution()">
      </button-induxtry>
    </div>
    }
  </div>

  <tabs-induxtry #detailTabs [disableBackground]="true" (onChange)="onTabsChange($event)">
    <tab-induxtry [title]="detailsTabTitle()" [active]="true">
      @if (pipelineStagesConfig().length > 0) {
      <div class="pipeline-stages-strip">
        @for (stage of pipelineStagesConfig(); track stage.type; let i = $index) {
        @if (i > 0) {
        <div style="padding: 0 8px;">
          <icon-induxtry [icon]="{ 
              icon: pipelineStagesConfig()[i-1].status === 'failure' ? 'error' : 'arrow-right-new', 
              stroke: pipelineStagesConfig()[i-1].status === 'failure' ? '' : '#000',
              width: 24,
              height: 24
            }"></icon-induxtry>
        </div>
        }
        <app-pipeline-stage-card [title]="stage.title" [subtitle]="stage.subtitle" [status]="stage.status"
          [dashboardData]="stage.dashboardData" [isLoading]="stage.isLoading" [isSelected]="stage.isSelected"
          [steps]="stage.steps" [showFollowLogsButton]="stage.status === 'processing'"
          [disabled]="stage.status !== 'completed' && stage.status !== 'failure'"
          (cardClick)="onStageCardClick(stage.type)" (followLogsClick)="onFollowLogs(stage.layerId)">
        </app-pipeline-stage-card>
        }
      </div>
      
        @if (selectedLayerIsFailed()) {
          <!-- <app-alerts-item-details></app-alerts-item-details> -->
          <span class="log-execution-description">Visualize os registros de eventos da camada selecionada, incluindo
            status
            e possíveis erros.</span>
          <app-pipeline-layers-console [layers]="[selectedLayer()!]" [jobId]="selectedVersionId()"
            [initialSelectedLayerId]="selectedLayer()?._id">
          </app-pipeline-layers-console>
        } @else {
          @if (advancedAnalysisTemporalData() && !isBBCEDataSetID()) {
          <advanced-analysis [temporalData]="advancedAnalysisTemporalData()!"
            [rupturesData]="advancedAnalysisRupturesData() ?? {}">
          </advanced-analysis>
          } @else if (!isLoadingTabs()) {
          <div class="empty-state-wrapper">
            <empty-state icon="TrendingUp" title="Nenhum dado disponível"
              description="Não foi possível carregar a análise temporal para esta versão e camada selecionada.">
            </empty-state>
          </div>
          }
        }
      }
    </tab-induxtry>
    <tab-induxtry title="Histórico de execuções" [active]="true">
      <app-pipeline-runs [jobId]="selectedVersionId()" [runsInput]="executions()" [selectedRunId]="selectedVersionId()"
        [selectedJobLayers]="layers()"
        [layersLoading]="isLoadingLayers()"
        [expandedRunId]="focusLogsForLayerId() ? selectedVersionId() : null"
        [initialSelectedLayerId]="focusLogsForLayerId()" [totalCount]="executionsTotalCount()"
        [page]="executionsPage()" [pageSize]="executionsPageSize()" [isLoading]="isLoadingExecutions()"
        [filters]="executionsFilters()" [statusCounts]="executionsStatusCounts()"
        (pageChange)="onExecutionsPageChange($event)" (filtersChange)="onExecutionsFiltersChange($event)"
        (viewExecution)="onExecutionSelected($event)">
      </app-pipeline-runs>
    </tab-induxtry>
  </tabs-induxtry>
  }
</div>